<template>
  <div class="legend-wrap">
    <!-- 左侧 -->
    <div class="legend">
      <div class="legend-item"
        ref="legendItem"
        :class="{active: item.selected}"
        v-for="(item,index) of legendLeft"
        :key="index"
        :style="[{color: item.selected ? colors[index] : ''}]"
        @click.stop="handleLegendClick(item, index)"
      >
        <div class="legend-item-left" v-if="item.name" :style="{width: item.value ? '70%' : '100%'}">
          <span class="legend-item-dot" :style="{background:colors[index]}"></span>
          <span class="legend-item-name text-ellipsis">{{ item.name }}</span>
        </div>
        <span class="legend-item-count" v-if="item.value">{{ item.value }}</span>
      </div>
    </div>
    <!-- 右侧 -->
    <div class="legend">
      <div class="legend-item"
        ref="legendItem"
        :class="{active: item.selected}"
        v-for="(item,index) of legendRight"
        :key="index"
        :style="[{color: item.selected ? colors[index] : ''}]"
        @click.stop="handleLegendClick(item, index)"
      >
        <div class="legend-item-left" v-if="item.name" :style="{width: item.value ? '70%' : '100%'}">
          <span class="legend-item-dot" :style="{background:colors[index]}"></span>
          <span class="legend-item-name text-ellipsis">{{ item.name }}</span>
        </div>
        <span class="legend-item-count" v-if="item.value">{{ item.value }}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {
  Button
} from 'vant'
import { colors } from '@/common/config'

export default {
  components: {
    [Button.name]: Button
  },
  props: {
    chartData: {
      type: Array,
      default() {
        return []
      }
    },
    color: {
      type: Array,
      default() {
        return []
      }
    },
    // 一行默认分两列
    legendCols: {
      type: [Number, String],
      default: 2
    },
    // 根据父级传入参数判断是否显示展开按钮,废弃
    showBtn: {
      type: Boolean,
      default: false
    },
    // 点击legend触发的行为:如 highlight、select
    legendAction: {
      type: String,
      default: ''
    },
    legendLeft: {
      type: Array,
      default() {
        return []
      }
    },
    legendRight: {
      type: Array,
      default() {
        return []
      }
    }
  },
  data() {
    return {
      maxRow: 10, // 超过几行显示展开按钮
      unfold: false, // 是否展开图例,
      legendItemHeight: 0, // 单个legend-item的高度
    }
  },
  computed: {
    // legend一行分几列
    legendColsStyle() {
      const percent = 1 / this.legendCols * 100
      return {
        width: `calc(${percent}% - 16 * 2px)`,
        padding: `0 16px`
      }
    },
    // 根据legend长度判断是否显示展开按钮
    isShowBtn() {
      return this.chartData.length > (this.maxRow * this.legendCols)
    },
    // legend最大高度
    legendHeightStyle() {
      // 屏幕宽750时，1rem为37.5px, legend-item的高度为26px
      // 以此动态计算legend-item的高度
      const htmlFontSize = document.documentElement.style.fontSize.replace('px', '')
      const legendItemHeight = htmlFontSize * this.legendItemHeight / 37.5
      const flag = this.chartData.length > (this.maxRow * this.legendCols)
      return {
        'max-height': flag ? `${legendItemHeight * this.maxRow}px` : 'auto'
      }
    },
    colors() {
      return colors
    }
  },
  watch: {
    chartData() {
      this.$nextTick(() => {
        const legnedItem = this.$refs.legendItem[0]
        if(legnedItem) { // 12为legned-item的margin-bottom值，加在一起为legend-ietm盒子的高度
          this.legendItemHeight = legnedItem.offsetHeight + 12
        }
      })
    }
  },
  methods: {
    // 切换展开状态
    handleLegendFold() {
      this.unfold = !this.unfold
    },
    // 点击legend
    handleLegendClick(item) {
      if(!item.name) return;
      const flag = item.selected
      const chart = this.$parent.chart
      if(chart) {
        this.chartData.forEach((iten) => {
          this.$set(iten, 'selected', false)
        })
        item.selected = !flag
        if(this.legendAction === 'highlight') {
          this.chartData.forEach((iten,ind) => {
            chart.dispatchAction({
              type: 'downplay',
              dataIndex: ind
            })
          })
          // 饼图触发高亮方法
          chart.dispatchAction({
            type: item.selected ? 'highlight' : 'downplay',
            name: item.name
          })
          chart.dispatchAction({
            type: item.selected ? 'showTip' : 'hideTip',
            seriesIndex: 0,
            name: item.name
          })
          return
        }

        // if(typeof item.selected === 'undefined') {
        //   this.$set(item, 'selected', true)
        // }else {
        //   item.selected = !item.selected
        // }
        // 柱状图触发select方法,只选中当前项
        const isUnSelectAll = this.chartData.every(item => {
          return !item.selected
        })
        if(isUnSelectAll) { // 全部选中
          chart.dispatchAction({
            type: 'legendAllSelect'
          })
        }else { // 只选中当前点击项
          this.chartData.forEach((iten) => {
            chart.dispatchAction({
              type: 'legendUnSelect',
              name: iten.name
            })
          })
          chart.dispatchAction({
            type: 'legendSelect',
            name: item.name
          })
          chart.dispatchAction({
            type: 'legendSelect',
            name: '总数'
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.legend-wrap {
  display: flex;
  .legend {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    flex: 1;
    overflow: hidden;
    &.active {
      max-height: 999px !important;
    }
    .legend-item {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 12px;
      padding: 0 16px;
      .legend-item-dot {
        flex-shrink: 0;
        display: inline-block;
        width: 6px;
        height: 6px;
        border-radius: 50%;
        background: #3366ff;
      }
      .legend-item-left {
        display: flex;
        align-items: center;
        /* width: 70%; */
      }
      .legend-item-name {
        margin-left: 10px;
      }
      .legend-item-count {
        align-items: flex-end;
        font-size: 16px;
        font-weight: bold;
      }
    }
  }
  .action {
    display: flex;
    justify-content: center;
    padding-bottom: 12px;
    .van-button {
      color: #3366FF !important;
    }
  }
}
</style>
